export default "__VITE_ASSET__1HFDBf09__"